import React, { useContext } from "react";
import ReactDOM from "react-dom";
import { Pie, PieConfig } from "@ant-design/plots";
type DonutChartProps = {
  actualValue: number;
  maxValue: number;
};
const getBarevneSchema = (value: number, maxValue: number) => {
  const percent = (value / maxValue) * 100;
  //todo nahradit za context
  if (percent < 50) {
    return ["#52c41a", "#808080"];
  } else if (percent < 80) {
    return ["#f59f1e", "#808080"];
  } else {
    return ["#eb2323", "#808080"];
  }
};
export const DonutProgressChart: React.FC<DonutChartProps> = ({
  actualValue,
  maxValue,
}) => {
  const progressProcento = React.useMemo(
    () => (actualValue / maxValue) * 100,
    [actualValue, maxValue]
  );
  const data =
    progressProcento > 100
      ? [{ type: "Actual", value: 100 }]
      : [
          {
            type: "Actual",
            value: actualValue <= 0 ? null : actualValue,
          },
          {
            type: "Max",
            value: actualValue <= 0 ? 100 : maxValue - actualValue,
          },
        ];
  const config: PieConfig = React.useMemo(() => {
    return {
      appendPadding: 10,
      data,
      angleField: "value",
      legend: false,
      colorField: "type",
      radius: 1,
      innerRadius: 0.75,
      style: {
        height: "150px",
      },
      label: {
        content: "",
      },
      color: getBarevneSchema(actualValue, maxValue),
      statistic: {
        title: false,
        content: {
          style: {
            whiteSpace: "pre-wrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: "20px",
          },
          content: `${
            progressProcento ? Math.round(progressProcento).toString() : 0
          }%`,
        },
      },
    };
  }, [actualValue, maxValue]);
  return <Pie {...config} />;
};
